import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMapStore } from '@/stores/mapStore';

export default function HighlightPulse() {
  const map = useMap();
  const highlightPosition = useMapStore((s) => s.highlightPosition);
  const markerRef = useRef<L.CircleMarker | null>(null);

  useEffect(() => {
    // Remove previous
    if (markerRef.current) {
      map.removeLayer(markerRef.current);
      markerRef.current = null;
    }

    if (!highlightPosition) return;

    const [lat, lon] = highlightPosition;
    const marker = L.circleMarker([lat, lon], {
      radius: 15,
      color: '#3b82f6',
      weight: 3,
      opacity: 0.8,
      fillColor: '#3b82f6',
      fillOpacity: 0.2,
      className: 'highlight-pulse',
    });

    marker.addTo(map);
    markerRef.current = marker;

    // Auto-remove after 3 seconds
    const timer = setTimeout(() => {
      if (markerRef.current) {
        map.removeLayer(markerRef.current);
        markerRef.current = null;
      }
    }, 3000);

    return () => {
      clearTimeout(timer);
      if (markerRef.current) {
        map.removeLayer(markerRef.current);
        markerRef.current = null;
      }
    };
  }, [highlightPosition, map]);

  return null;
}
